// extracted by mini-css-extract-plugin
export var constrained = "shop-panel-with-inset-image-module--constrained--d65d0";
export var content = "shop-panel-with-inset-image-module--content--0c962";
export var copyContainer = "shop-panel-with-inset-image-module--copyContainer--e3776";
export var copyDesktopOnly = "shop-panel-with-inset-image-module--copyDesktopOnly--d27ae";
export var copyMobileOnly = "shop-panel-with-inset-image-module--copyMobileOnly--a101f";
export var ctaLink = "shop-panel-with-inset-image-module--ctaLink--34ed1";
export var description = "shop-panel-with-inset-image-module--description--5d158";
export var image = "shop-panel-with-inset-image-module--image--45c04";
export var imageContainer = "shop-panel-with-inset-image-module--imageContainer--bbe7e";
export var imageOnLeft = "shop-panel-with-inset-image-module--imageOnLeft--90d2c";
export var unconstrained = "shop-panel-with-inset-image-module--unconstrained--5d4de";